import { IProviderConfiguration } from "../IProviderConfiguration";


export default class PaytOutInvoices implements IProviderConfiguration {

    private baseUri: string = 'https://app.paytsoftware.com/oauth/authorize';

    public getApplicationName(): string {
        return 'payt';
    }

    public isOAuth2Provider(): boolean {
        return true;
    }

    public getAuthorizeUri(clientId: string, redirectUri: string): string {
        const state = this.generateState();
        return `${this.baseUri}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&state=${state}`;
    }

    public needsExtraConnectionContext(): boolean {
        return true;
    }

    private generateState(): string {
        return Math.random().toString(36).substring(2);
    }
}
